import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ProgramTemplateWrapper = styled.div`
  .program-template-wrapper {
    width: 100%;
    background-color: ${COLORS.cirrus_black1};
  }
  .program-template {
    padding: 24px 16px 48px;
    border-bottom: 1px dashed ${COLORS.primary_light_blue};

    ${responsive.MOBILE`
        padding: 16px 8px;
    `}
  }
  .program-template-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    ${responsive.MOBILE`
        align-items: center;
    `}
  }
  .delete-icon {
    margin-right: 8px;
  }
  .add-program-template {
    display: flex;
    justify-content: flex-end;
    padding: 32px 16px;
    background-color: ${COLORS.cirrus_black1};

    .btn-tertiary {
      height: 20px;
    }
  }
`;
